import { H6, P, Image } from '@template/components';
import * as S from './styles.ts';
import { StaticImageData } from 'next/image';

export interface IInternationalCostCardProps {
  destination: string;
  destinationFlagUrl: string | StaticImageData;
  priceDetails?: { price: string; copy: string }[];
  showLabels?: boolean;
}

export const InternationalCostCard = ({
  destination,
  destinationFlagUrl,
  priceDetails,
  showLabels,
}: IInternationalCostCardProps) => {
  return (
    <S.IntlCostCardContainer $showLabels={showLabels}>
      <S.Labels $showLabels={showLabels}>
        <S.Destination>
          <P>Destination</P>
        </S.Destination>

        {priceDetails?.map((detail, index) => (
          <S.PriceLabel key={index}>
            <P>{detail.copy}</P>
            <P>/min</P>
          </S.PriceLabel>
        ))}
      </S.Labels>

      <S.Row>
        <S.Destination>
          <S.Flag>
            <Image
              src={destinationFlagUrl}
              alt={`Flag of ${destination}`}
              width={32}
              height={32}
            />
          </S.Flag>
          <H6>{destination}</H6>
        </S.Destination>

        {priceDetails?.map((detail, index) => (
          <S.Price key={index}>
            <P>{detail.price}P</P>
          </S.Price>
        ))}
      </S.Row>
    </S.IntlCostCardContainer>
  );
};
